module.exports = __webpack_public_path__ + "142f7501b4322b1ae1082b064fbcbf3a.svg";